const awsS3Storage={ 
    bucket: 'drowl-users-direct-upload',
    region: 'us-west-2'
 }

 export default awsS3Storage;